<div class="bill-group-card" [ngClass]="getCardClass()">
  <!-- Header with period and confidence badge -->
  <div class="card-header">
    <div class="header-left">
      <span class="period-label">
        {{ formatDate(group.billingPeriod.start) }} – {{ formatDate(group.billingPeriod.end) }}
      </span>
      @if (isPaired()) {
        <span class="confidence-badge" [ngClass]="group.matchConfidence">
          <i class="material-symbols-rounded">link</i>
          <span>{{ getConfidenceLabel() }}</span>
        </span>
      }
    </div>
    <div class="header-right">
      <span class="amount">{{ group.combinedAmount | currency }}</span>
      @if (group.combinedUsage > 0) {
        <span class="usage">
          {{ group.combinedUsage | number:'1.0-0' }} {{ group.usageUnit }}
        </span>
      }
    </div>
  </div>

  <!-- Split view: Utility | Supplier -->
  <div class="card-body">
    <!-- Utility Bill Side -->
    <div class="bill-side utility" [ngClass]="group.utilityBill ? 'has-bill' : 'empty'">
      <div class="bill-header">
        <app-bill-type-badge [type]="'utility'"></app-bill-type-badge>
        @if (group.utilityBill) {
          <div class="action-buttons">
            <button (click)="onView.emit(group.utilityBill)" class="action-btn view" title="View Bill">
              <i class="material-symbols-rounded">visibility</i>
            </button>
            <button (click)="onEdit.emit(group.utilityBill)" class="action-btn edit" title="Edit Bill">
              <i class="material-symbols-rounded">edit</i>
            </button>
          </div>
        }
      </div>

      @if (group.utilityBill) {
        <div class="bill-content">
          <div class="file-info">
            <i class="material-symbols-rounded">description</i>
            <span class="file-name" [title]="group.utilityBill.file.name">
              {{ group.utilityBill.file.name }}
            </span>
          </div>
          <div class="bill-amount">
            {{ group.utilityBill.data?.totalAmount | currency }}
          </div>
          <div class="bill-provider" [title]="group.utilityBill.data?.utilityName || ''">
            {{ group.utilityBill.data?.utilityName || 'Unknown Utility' }}
          </div>
        </div>
      } @else {
        <div class="empty-state">
          <div class="empty-icon">
            <i class="material-symbols-rounded">power</i>
          </div>
          <span class="empty-text">No utility bill</span>
        </div>
      }

    </div>

    <!-- Supplier Bill Side -->
    <div class="bill-side supplier" [ngClass]="group.supplierBill ? 'has-bill' : 'empty'">
      <div class="bill-header">
        <app-bill-type-badge [type]="'supplier'"></app-bill-type-badge>
        @if (group.supplierBill) {
          <div class="action-buttons">
            <button (click)="onView.emit(group.supplierBill)" class="action-btn view" title="View Bill">
              <i class="material-symbols-rounded">visibility</i>
            </button>
            <button (click)="onEdit.emit(group.supplierBill)" class="action-btn edit" title="Edit Bill">
              <i class="material-symbols-rounded">edit</i>
            </button>
          </div>
        }
      </div>

      @if (group.supplierBill) {
        <div class="bill-content">
          <div class="file-info">
            <i class="material-symbols-rounded">description</i>
            <span class="file-name" [title]="group.supplierBill.file.name">
              {{ group.supplierBill.file.name }}
            </span>
          </div>
          <div class="bill-amount">
            {{ group.supplierBill.data?.totalAmount | currency }}
          </div>
          <div class="bill-provider" [title]="group.supplierBill.data?.providerName || ''">
            {{ group.supplierBill.data?.providerName || 'Unknown Supplier' }}
          </div>
        </div>
      } @else {
        <div class="empty-state">
          <div class="empty-icon">
            <i class="material-symbols-rounded">bolt</i>
          </div>
          <span class="empty-text">No supplier bill</span>
        </div>
      }

    </div>
  </div>

  <!-- Match reason footer (only for paired bills) -->
  @if (isPaired() && group.matchReason) {
    <div class="card-footer">
      <i class="material-symbols-rounded">info</i>
      <span>{{ group.matchReason }}</span>
    </div>
  }
</div>
